import axios from 'axios';

const BASE_URL = '/api/super-admin';

export async function getSuperAdminDashboard() {
    const response = await axios.get(`${BASE_URL}/dashboard`);
    return response.data;
}

export async function listTenants() {
    const response = await axios.get(`${BASE_URL}/tenants`);
    return response.data;
}

export async function getTenantDetails(tenantId) {
    const response = await axios.get(`${BASE_URL}/tenants/${tenantId}`);
    return response.data;
}

export async function createTenant(payload) {
    const response = await axios.post(`${BASE_URL}/tenants`, payload);
    return response.data;
}

export async function createSystemInternalUser(payload) {
    const response = await axios.post(`${BASE_URL}/system-internal-users`, payload);
    return response.data;
}

export async function updateTenantUserLocations(tenantId, userId, payload) {
    const response = await axios.put(`${BASE_URL}/tenants/${tenantId}/users/${userId}/locations`, payload);
    return response.data;
}

export async function updateTenant(tenantId, payload) {
    const response = await axios.put(`${BASE_URL}/tenants/${tenantId}`, payload);
    return response.data;
}

export async function suspendTenant(tenantId) {
    const response = await axios.post(`${BASE_URL}/tenants/${tenantId}/suspend`);
    return response.data;
}

export async function activateTenant(tenantId) {
    const response = await axios.post(`${BASE_URL}/tenants/${tenantId}/activate`);
    return response.data;
}
